"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CountryFlag = function CountryFlag(_ref) {
  var isoCode = _ref.isoCode;
  return /*#__PURE__*/_react.default.createElement("img", {
    src: "https://flagcdn.com/28x21/".concat(isoCode.toLowerCase(), ".png"),
    alt: "flag"
  });
};

var _default = CountryFlag;
exports.default = _default;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy91dGlscy9Db3VudHJ5RmxhZy50c3giXSwibmFtZXMiOlsiQ291bnRyeUZsYWciLCJpc29Db2RlIiwidG9Mb3dlckNhc2UiXSwibWFwcGluZ3MiOiI7Ozs7Ozs7QUFBQTs7OztBQUVBLElBQU1BLFdBQW9DLEdBQUcsU0FBdkNBLFdBQXVDO0FBQUEsTUFBR0MsT0FBSCxRQUFHQSxPQUFIO0FBQUEsc0JBQzNDO0FBQUssSUFBQSxHQUFHLHNDQUErQkEsT0FBTyxDQUFDQyxXQUFSLEVBQS9CLFNBQVI7QUFBb0UsSUFBQSxHQUFHLEVBQUM7QUFBeEUsSUFEMkM7QUFBQSxDQUE3Qzs7ZUFJZUYsVyIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCBSZWFjdCwgeyBGQyB9IGZyb20gJ3JlYWN0JztcblxuY29uc3QgQ291bnRyeUZsYWc6IEZDPHsgaXNvQ29kZTogc3RyaW5nIH0+ID0gKHsgaXNvQ29kZSB9KSA9PiAoXG4gIDxpbWcgc3JjPXtgaHR0cHM6Ly9mbGFnY2RuLmNvbS8yOHgyMS8ke2lzb0NvZGUudG9Mb3dlckNhc2UoKX0ucG5nYH0gYWx0PVwiZmxhZ1wiIC8+XG4pO1xuXG5leHBvcnQgZGVmYXVsdCBDb3VudHJ5RmxhZztcbiJdfQ==